import Vue from 'vue'
import Router from 'vue-router'

/* Layout */
import Layout from '@/layout'

import epcRouter from './modules/epc'
import systemRouter from './modules/system'
import relationManageRouter from './modules/relationManage'
import supplierRouter from './modules/supplier'


// import techDocManagementRouter from './modules/tech-doc-namagement'


/* Router Modules */

Vue.use(Router)

/* Router Modules */

export const constantRoutes = [

  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/login'),
    hidden: true
  },
  {
    path: '/visitor',
    component: () => import('@/views/public/visitor'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: { title: 'routeSearchVin', icon: 'icons1' }
      }
    ]
  },
  {
    path: '/vehicle',
    component: Layout,
    children: [
      {
        path: 'vehicleQuery',
        component: () => import('@/views/vehicle/vehicleQuery'),
        name: 'VehicleQuery',
        meta: { title: 'routeVehicleCode', icon: 'icons2' }
      }
    ]
  },
  {
    path: '/vehicle1',
    component: Layout,
    children: [
      {
        path: 'modelNavigation',
        component: () => import('@/views/vehicle/modelNavigation'),
        name: 'ModelNavigation',
        meta: { title: 'routeNavigation', icon: 'icons3' }
      }
    ]
  },
  {
    path: '/vehicle2',
    component: Layout,
    children: [
      {
        path: 'assembly',
        component: () => import('@/views/vehicle/assembly'),
        name: 'Assembly',
        meta: { title: 'routeAssemblyNavigation', icon: 'icons4' }
      }
    ]
  },
  {
    path: '/vehicle3',
    component: Layout,
    children: [
      {
        path: 'componentQuery',
        component: () => import('@/views/vehicle/componentQuery'),
        name: 'ComponentQuery',
        meta: { title: 'routePartsQuery', icon: 'icons5' }
      }
    ]
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  /** 配件目录 **/
  // epcRouter,
  /** 后台管理 **/
  // systemRouter,
    /** 技术通告管理 **/
    // techDocManagementRouter,
    epcRouter,
    supplierRouter,
    systemRouter,
    relationManageRouter,
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
